/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

// eslint-disable-next-line import/no-unresolved
import JsController from '../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'takeover-highlights');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

// Handle scroll arrow click
const handleScrollArrowClick = (controller: JsController, element: HTMLElement) => {

    const slideArrows = element.querySelectorAll('.scroll-to-bottom-of-takeover');

    if (slideArrows.length > 0) {
        for (const slideArrow of slideArrows) {
            controller.addListener(slideArrow, "click", () => {
                const navigation = document.querySelector<HTMLElement>('.navigation');
                const navigationHeight = navigation ? navigation.clientHeight : 0;
                const scrollToPos = element.getBoundingClientRect().bottom + window.scrollY - navigationHeight;
                window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
            });
        }
    }
}

export function mountComponent( controller: JsController ) {
    const elements = document.querySelectorAll<HTMLElement>(".takeover-highlights");
    for (const element of elements) {
        handleScrollArrowClick(controller,element)
    }
}
